<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Дополнительные возможности - Текстуры материалов
                </h3>
            </div>
            <aside class="col-md-4">
                <MenuComponent/>
            </aside>
            <div class="col-md-8 mb-3">
                <a href="https://media.foroom.ru/2012/texture/goriz_jalusi_texture_2016.rar" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/archive.png" alt="archive">
                            </div>
                            <div class="col-md-11">
                                Горизонтальные жалюзи
                            </div>
                        </div>
                    </div>
                </a>
                <a href="https://media.foroom.ru/2012/texture/krugl_corniz_texture.zip" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/archive.png" alt="archive">
                            </div>
                            <div class="col-md-11">
                                Круглые карнизы
                            </div>
                        </div>
                    </div>
                </a>
<!--                <a href="https://media.foroom.ru/2012/texture/ready_made_texture.zip" class="card mb-3">-->
<!--                    <div class="card-body">-->
<!--                        <div class="row">-->
<!--                            <div class="col-md-1 icon">-->
<!--                                <img src="@/assets/img/archive.png" alt="archive">-->
<!--                            </div>-->
<!--                            <div class="col-md-11">-->
<!--                                Ready Made Рулонные шторы-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </a>-->
                <a href="https://media.foroom.ru/2012/texture/rimskie_shtory_texture_2016.zip" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/archive.png" alt="archive">
                            </div>
                            <div class="col-md-11">
                                Римские шторы
                            </div>
                        </div>
                    </div>
                </a>
                <a href="https://media.foroom.ru/2012/texture/rulonnye_shtory_texture_2017.zip" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/archive.png" alt="archive">
                            </div>
                            <div class="col-md-11">
                                Рулонные шторы
                            </div>
                        </div>
                    </div>
                </a>
                <a href="https://media.foroom.ru/2012/texture/vert_jalusi_texture_2016.rar" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/archive.png" alt="archive">
                            </div>
                            <div class="col-md-11">
                                Вертикальные жалюзи
                            </div>
                        </div>
                    </div>
                </a>
                <a href="https://sale.katris.ru/files/zebra_texture_2020.zip" class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-1 icon">
                                <img src="@/assets/img/archive.png" alt="archive">
                            </div>
                            <div class="col-md-11">
                                Zebra Рулонные шторы
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </main>
</template>

<script>
    import MenuComponent from '../components/AdditionalFeaturesMenu';

    export default {
        name: "Textures",
        metaInfo: {
            title: 'Текстуры материалов',
            titleTemplate: '%s - sale.katris'
        },
        components: {
            MenuComponent
        }
    }
</script>

<style scoped>
    .card-body {
        padding: 10px;
    }
    .icon i {
        font-size: 24px
    }
</style>